import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import { useAuth } from './contexts/auth';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import axios from 'axios';


export default function () {
    const { user, signOut } = useAuth();
    useEffect(() => {
        getConfigAsync()
    }, [])
    const getConfigAsync = async () => {
        const res = await axios.get(`${appInfo.api_url}/config`).catch((error) => {
        });
        if (res.data.is_success) {
            localStorage.setItem("home_url", res.data.data.PortalUrl)
            // setAppConfig(res.data.data)

        } else {
        }
    }
    const default_page = () => {
        return "/home";

    }
    return (
        <SideNavBarLayout title={appInfo.title}>
            <Switch>
                {routes.map(({ path, component }) => (
                    <Route
                        exact
                        key={path}
                        path={path}
                        component={component}
                    />
                ))}
                <Redirect to={default_page()} />
            </Switch>
        </SideNavBarLayout>

    );
}
